import fa from "./fa"
import en from "./en"

export default {
	fa,
	en
}
